<template>
	<div class="drawer-header">
		<div class="fold" @click="toClose">>> 收起</div>
		<div class="main">
			<div>
				<div  v-if="dataType == 2" class="xiansuo contactProfilePicture">{{ checkChinese }}</div>
				<img v-else :src="logo || require('@/assets/default.png')" class="img" />
			</div>
			<div class="right-info">
				<div class="name">{{ nickname }}</div>
				<div class="email" v-if="dataType == 2">
					{{ mobile }}
					<el-tooltip effect="dark" content="复制手机号" placement="top">
						<div class="icon_body">
							<ig-icon
								name="copy"
								v-clipboard="mobile"
								v-clipboard:success="clipboardSuccess"
								v-clipboard:error="onError"
							></ig-icon>
						</div>
					</el-tooltip></div>
				<div class="email" v-if="email">
					{{ email }}
					<!-- <el-tooltip effect="dark" content="发送邮件" placement="top">
						<div class="icon_body" >
							<ig-icon name="youxiang3"></ig-icon>
						</div>
					</el-tooltip> -->
					<el-tooltip effect="dark" content="复制邮箱地址" placement="top">
						<div class="icon_body">
							<ig-icon
								name="copy"
								v-clipboard="email"
								v-clipboard:success="clipboardSuccess"
								v-clipboard:error="onError"
							></ig-icon>
						</div>
					</el-tooltip>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
// import { create as createUrlParams } from '@/common/routerParams.js';
export default {
	props: {
		nickname: {
			type: String,
		},
		email: {
			type: String,
		},
		logo: {
			type: String,
		},
		dataType: null,
		mobile: {
			type: String
		}
	},
	data() {
		return {};
	},
	computed: {
		checkChinese() {
			let val = this.nickname;
			var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
			if (reg.test(val)) {
				return val.substring(0, 1);
			} else {
				if (val) {
					val = val.toLowerCase();
					let name = val.charAt(0).toUpperCase() + val.slice(1);
					return name.substring(0, 2);
				}
			}
			return '无';
		},
	},
	methods: {
		clipboardSuccess() {
			this.$message({
				message: '复制到剪贴板成功',
				type: 'success',
				duration: 1500,
			});
		},
		onError() {
			this.$message({
				message: '复制到剪切板失败',
			});
		},
		toClose() {
			this.$emit('changeSide', true);
		},
	},
	components: {},
};
</script>
<style lang="scss" scoped>
.drawer-header {
	width: 100%;
	// height: 180px;
	.fold {
		line-height: 55px;
		height: 55px;
		border-bottom: 1px #e8e8e8 solid;
		font-weight: 400;
		color: #333333;
		padding: 0px 20px;
		cursor: pointer;
	}
	.main {
		display: flex;
		margin: 20px 16px;
	}
	.img {
		background: #d3d6db;
		width: 70px;
		height: 70px;
		border-radius: 35px;
		object-fit: contain;
		display: inline-block;
		vertical-align: top;
	}
	.name {
		font-weight: 500;
		color: #333333;
		line-height: 22px;
		font-size: 16px;
		margin: 0px 0px 6px 0;
	}
	.email {
		display: flex;
		/* justify-content: center; */
	    flex-wrap: wrap;
		font-size: 14px;
		margin-bottom: 6px;
	}
	.right-info {
		margin-left: 15px;
	}
	.icon_body {
		cursor: pointer;
		text-align: center;
		margin-left: 5px;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		line-height: 20px;
		background-color: rgba(61, 161, 255, 1);
		font-size: 10px;
		color: #fff;

		.icon-youxiang3, .icon-copy {
			font-size: 14px;
		}
		
	}
}
.xiansuo {
  background: rgba(61, 161, 255, 0.16);
  border: 1px solid #3da1ff;
  color: #2691e9;
}
.contactProfilePicture {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  text-align: center;
  line-height: 70px;
  font-size: 18px;
}
</style>
